import styled from 'styled-components';

import useI18n from '../../common/hooks/useI18n';

import SectionTitle from './sectionTitle';
import CardsDisplay from './cardsDisplay';

type Props = {
  query: string;
  section: string;
};

const cardsSectionDict = {
  saveYourTime: {
    cardsCount: 6,
    verticalMode: false,
  },
  impossibleToSell: {
    cardsCount: 8,
    verticalMode: true,
  },
};

const Subtitle = styled.div`
  max-width: 80%;
  font-size: 18px;
  line-height: 32px;
  margin-bottom: 32px;

  @media ${(props) => props.theme.breakpoints.lgd} {
    font-size: 16px;
  }
  @media ${(props) => props.theme.breakpoints.smd} {
    max-width: unset;
    line-height: 22px;
  }
`;

const CardsSection: React.FC<Props> = ({ query, section }) => {
  const i18n = useI18n();

  const sectionInfo = cardsSectionDict[section];

  if (!sectionInfo) {
    return null;
  }

  return (
    <>
      <SectionTitle
        title={i18n.t(`dynamic.sellHousePage.${query}.${section}Title`)}
      />
      {i18n.t(`dynamic.sellHousePage.${query}.${section}Subtitle`) && (
        <Subtitle>
          {i18n.t(`dynamic.sellHousePage.${query}.${section}Subtitle`)}
        </Subtitle>
      )}

      <CardsDisplay
        query={query}
        section={section}
        cardsCount={sectionInfo.cardsCount}
        verticalMode={sectionInfo.verticalMode}
      />
    </>
  );
};

export default CardsSection;
